<ng-container
    *ngTemplateOutlet="template; context: { $implicit: containerLayout, closeFn: boundCloseFn }"
></ng-container>
